/**
 * Heart overlay sits on the gallery / card photo. Hiding .wish_item in the
 * same tap lets WebKit send a ghost click to the image (xzoom / fancybox).
 */
const BLOCK_MS = 450;
let blockUntil = 0;

function isWishControl(target) {
  return target instanceof Element
    && Boolean(target.closest('.wish_item, .product-card__wish, .pdp-gallery-stage > .like_icons'));
}

function isPhotoSurface(target) {
  return target instanceof Element
    && Boolean(target.closest('.pdp-gallery-stage, .product-card, .image_wrapper_block'));
}

export function initWishHitGuard() {
  if (document.documentElement.dataset.wishHitGuard === '1') {
    return;
  }
  document.documentElement.dataset.wishHitGuard = '1';

  document.addEventListener('pointerdown', (event) => {
    if (isWishControl(event.target)) {
      event.stopPropagation();
      blockUntil = Date.now() + BLOCK_MS;
    }
  }, true);

  document.addEventListener('click', (event) => {
    if (Date.now() > blockUntil) {
      return;
    }
    if (isWishControl(event.target) || !isPhotoSurface(event.target)) {
      return;
    }
    event.preventDefault();
    event.stopPropagation();
    if (typeof event.stopImmediatePropagation === 'function') {
      event.stopImmediatePropagation();
    }
  }, true);
}
